<div class="modal-observation open" #modal>
  <div class="ion-padding container-flex">
    <button class="bt-close" *ngIf="enabledClose">
      <ion-icon name="close-circle" (click)="close()"></ion-icon>
    </button>
    <ng-content></ng-content>
  </div>
</div>